// refs: https://stackoverflow.com/questions/48515023/display-different-vuejs-components-for-mobile-browsers
export const PomodoroMixin = {
    methods: {
        isMobile() {
            if (/webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || this.isAndroid() || this.isIOS()) {
                return true;
            } else {
                return false;
            }
        },
        isAndroid() {
            if (/Android/i.test(navigator.userAgent)) {
                return true;
            } else {
                return false;
            }
        },
        isIOS() {
            if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
                return true;
            } else {
                return false;
            }
        }
    }
};
